import actions from '@/core/store/adesao/actions'
import state from '@/core/store/adesao/state'
import getters from '@/core/store/adesao/getters'
import mutations from '@/core/store/adesao/mutations'
import documentosAdesao from '@/core/store/adesao/documentos-adesao'
import itensAdesao from '@/core/store/adesao/itens-adesao'
import revisoes from '@/core/store/adesao/revisoes'

export default {
	actions,
	state,
	getters,
	mutations,
	modules: {
		documentosAdesao,
		itensAdesao,
		revisoes,
	},
}
